import { stagePointError } from '.'
import { UnitPointType } from '../../../../../store/Itinerary'
import { IndividualStagePointRule } from '../../../../../store/StageFile'

export const locationIsValid: IndividualStagePointRule = (stagePoint) => {
    if (stagePoint.type.unitPointType != UnitPointType.TimeControl && (stagePoint.latitude == 0 || stagePoint.longitude == 0)) {
        return stagePointError(stagePoint, `Lat/Lon cannot be blank`)
    }
}